import React, { useMemo } from 'react';
import Typography from '@material-ui/core/Typography';
import { Button, Grid } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import EditIcon from '@material-ui/icons/Edit';
import ProductionSheetsView from './ProductionSheetsView';
import { RootStateOrAny, useSelector } from 'react-redux';
import DeleteIcon from '@material-ui/icons/Delete';
import Temperatures from './Temperatures';
import { useTranslation } from 'react-i18next';
import { BRANDS } from '../../types/brands';
import { TEMPERATURETYPES } from '../../types/temperatureTypes';
import {
  transformCommodityProfileApiResponseToCategoryProductSheet,
  transformMenuItemProfileApiResponseToProductSheet,
} from '../../utils/transformers/productSheet';

interface ItemperatureRender {
  displayTitle: string;
  temperatureName: string;
}

export function ShowOnlyProfile(props) {
  const { t } = useTranslation();
  const { selectedBrand } = useSelector(
    (state: RootStateOrAny) => state.UIReducer,
  );
  const {
    classes,
    canEdit = false,
    profile,
    canDelete = false,
    handleDelete = () => () => {},
    handleOpenEditMode,
    index,
    title,
    propertiesToRender,
    commodityGroupProductSheet,
    isDeleteDisabled = false,
  } = props;

  if (selectedBrand === BRANDS.TH) {
    //removing chilled temperature fields for TH
    const index = propertiesToRender.findIndex(
      p => p.displayTitle === TEMPERATURETYPES.CHILLED,
    );
    if (index > -1) {
      propertiesToRender.splice(index, 1);
    }
  }

  const memoProductSheet = useMemo(() => {
    if (commodityGroupProductSheet) {
      return transformCommodityProfileApiResponseToCategoryProductSheet(
        profile.productSheet,
      );
    } else {
      return transformMenuItemProfileApiResponseToProductSheet(
        profile.productSheet,
      );
    }
  }, [commodityGroupProductSheet, profile]);

  return (
    <Grid container>
      <Grid item xs={4} className={classes.separation}>
        <Typography>{title}</Typography>
      </Grid>
      <Grid item xs={4} className={classes.separation}>
        <Typography>
          {`${profile?.region} ${
            profile?.country?.name !== undefined
              ? '/ ' + profile.country.name
              : ''
          } ${
            profile?.state?.name !== undefined ? '/ ' + profile.state.name : ''
          }`}
        </Typography>
      </Grid>
      <Grid
        item
        style={{
          textAlign: 'right',
          marginTop: 10,
          marginBottom: 10,
          marginLeft: 'auto',
        }}
      >
        {canDelete && (
          <Button
            variant="outlined"
            size="small"
            startIcon={<DeleteIcon />}
            onClick={handleDelete(index, profile.id)}
            disabled={isDeleteDisabled}
          >
            {t('app.common.delete')}
          </Button>
        )}
      </Grid>
      <Grid
        item
        style={{
          textAlign: 'right',
          marginTop: 10,
          marginLeft: 10,
          marginBottom: 10,
        }}
      >
        {canEdit && (
          <Button
            variant="outlined"
            size="small"
            startIcon={<EditIcon />}
            onClick={handleOpenEditMode(index, profile.id)}
          >
            {t('app.common.edit')}
          </Button>
        )}
      </Grid>
      {selectedBrand === BRANDS.TH && (
        <>
          <Grid item xs={12} className={classes.separation}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <ProductionSheetsView productSheet={memoProductSheet} />
          </Grid>
        </>
      )}
      {propertiesToRender?.map((obj: ItemperatureRender, key) => (
        <React.Fragment key={key}>
          {profile[obj.temperatureName] && (
            <>
              {profile[obj.temperatureName]?.display ? (
                <>
                  <Grid item xs={12} className={classes.separation}>
                    <Divider />
                  </Grid>
                  <Temperatures
                    profile={profile}
                    name={obj.displayTitle}
                    temperature={obj.temperatureName}
                  />
                </>
              ) : null}
            </>
          )}
        </React.Fragment>
      ))}
    </Grid>
  );
}
